import { EmployeeStatus } from '../client/clientTypes';
export function getEmployeeStatusDescription(status) {
    switch (status) {
        case EmployeeStatus.Active:
            return 'Работает';
        case EmployeeStatus.Inactive:
            return 'Уволен';
        case EmployeeStatus.None:
            return '—';
        default:
            return '—';
    }
}
